import { ViewStream, ChannelPayloadFilter } from 'spyne';

export class PageDocsItemTitleExamples extends ViewStream {
  constructor(props = {}) {
    props.channels = ["CHANNEL_CODE_CONTAINER"];
    super(props);
  }

  addActionListeners() {

    const payloadFilter = new ChannelPayloadFilter({

      "codeBlockId" : "define"
    })

    return [
        ["CHANNEL_CODE_CONTAINER_UPDATE_EVENT", "onCodeContainerChangeEvent", payloadFilter]
    ];
  }

  onCodeContainerChangeEvent(e){
    const {menuTitle} = e.payload;
   //console.log("CODE CHANGE TITLE EVENT ",e.payload);

    this.updateText(menuTitle);

  }

  updateText(exampleTitle){
    //this.props.el.innerHTML = `Examples: <span class="examples">${exampleTitle}</span>`;

    if (this?.props?.exampleTitle$?.exists) {
      this?.props?.exampleTitle$?.removeClass('fade-in');
      this.props.exampleTitle$.el.innerText = exampleTitle;
      const onFadeIn = () => this?.props?.exampleTitle$?.addClass('fade-in');
      requestAnimationFrame(onFadeIn);
    }
  }

  onChannelRouteChangeEvent(e){
    const {routeData} = e.payload;
    const {exampleTitle} = routeData;

   //console.log("channel route change", {routeData}, this.props.data);

   // this.updateText(exampleTitle);
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {
   //console.log("EXAMPLES TITLE ")

    this.props.el.innerHTML = `<span class='examples-eyebrow nav-anchor-examples'>Edit this example on StackBlitz.</span>
Examples<em>:</em></em><span class='example-title'></span>`

    this.props.exampleTitle$ = this.props.el$('.example-title');

  }
}
